export const ITEMS_VISIBLE_THRESHOLD_DESKTOP = 17
export const ITEMS_VISIBLE_THRESHOLD_MOBILE = 7

export const SEARCH_AROUND_ME_TITLE = 'Current Location'
export const SEARCH_AROUND_ME_LOCATION_NAME = 'Your Location'
export const SEARCH_AROUND_ME_TERM = 'aroundLatLngViaIP'

export const MAXIMUM_LINK_ITEMS = 30

export const POPULAR_DESTINATIONS_LINKS = [
  { title: 'Australia', subtitle: 'Luxury Rehabs', url: '/australia/' },
  { title: 'Arizona', subtitle: 'Rehab Centers', url: '/arizona/' },
  { title: 'Bali', subtitle: 'Luxury Rehabs', url: '/bali/' },
  { title: 'California', subtitle: 'Rehab Centers', url: '/california/' },
  { title: 'Canada', subtitle: 'Treatment Centers', url: '/canada/' },
  { title: 'Colorado', subtitle: 'Rehab Centers', url: '/colorado/' },
  { title: 'Europe', subtitle: 'Rehab Centers', url: '/europe/' },
  { title: 'Florida', subtitle: 'Rehab Centers', url: '/florida/' },
  { title: 'India', subtitle: 'Rehab Centers', url: '/india/' },
  { title: 'Switzerland', subtitle: 'Luxury Rehabs', url: '/switzerland/' },
  { title: 'Thailand', subtitle: 'Luxury Rehabs', url: '/thailand/' },
  { title: 'New England', subtitle: 'Rehab Centers', url: '/new-england/' },
  { title: 'New York', subtitle: 'Treatment Centers', url: '/new-york/' },
  { title: 'Pennsylvania', subtitle: 'Rehab Centers', url: '/pennsylvania/' },
  { title: 'South Africa', subtitle: 'Luxury Rehabs', url: '/south-africa/' },
  { title: 'Texas', subtitle: 'Rehab Centers', url: '/texas/' },
  {
    title: 'United Kingdom',
    subtitle: 'Rehab Centers',
    url: '/united-kingdom/'
  }
]

export const CLIENTELE_LINKS = [
  { title: 'Men', subtitle: 'Treatment Centers', url: '/clientele/men/' },
  { title: 'LGBTQ+', subtitle: 'Treatment Centers', url: '/clientele/lgbtq/' },
  {
    title: 'Children',
    subtitle: 'Treatment Centers',
    url: '/clientele/children/'
  },
  {
    title: 'Young Adults',
    subtitle: 'Treatment Centers',
    url: '/clientele/young-adults/'
  },
  {
    title: 'Couples',
    subtitle: 'Treatment Centers',
    url: '/clientele/couples/'
  },
  {
    title: 'Christians',
    subtitle: 'Treatment Centers',
    url: '/approach/christian/'
  },
  { title: 'Women', subtitle: 'Treatment Centers', url: '/clientele/women/' },
  {
    title: 'Pregnant Women',
    subtitle: 'Treatment Centers',
    url: '/clientele/pregnant-women/'
  },
  {
    title: 'Teens',
    subtitle: 'Treatment Centers',
    url: '/clientele/adolescents/'
  },
  {
    title: 'Older Adults',
    subtitle: 'Treatment Centers',
    url: '/clientele/older-adults/'
  },
  {
    title: 'Executives',
    subtitle: 'Treatment Centers',
    url: '/clientele/executives/'
  },
  {
    title: 'Veterans',
    subtitle: 'Treatment Centers',
    url: '/clientele/veterans/'
  }
]

export const STATES_LINKS = [
  { title: 'Alabama', subtitle: 'Treatment Centers', url: '/alabama/' },
  { title: 'Alaska', subtitle: 'Treatment Centers', url: '/alaska/' },
  { title: 'Arizona', subtitle: 'Treatment Centers', url: '/arizona/' },
  { title: 'Arkansas', subtitle: 'Treatment Centers', url: '/arkansas/' },
  { title: 'California', subtitle: 'Treatment Centers', url: '/california/' },
  { title: 'Colorado', subtitle: 'Treatment Centers', url: '/colorado/' },
  { title: 'Connecticut', subtitle: 'Treatment Centers', url: '/connecticut/' },
  { title: 'Delaware', subtitle: 'Treatment Centers', url: '/delaware/' },
  { title: 'Florida', subtitle: 'Treatment Centers', url: '/florida/' },
  { title: 'Georgia', subtitle: 'Treatment Centers', url: '/georgia/' },
  { title: 'Hawaii', subtitle: 'Treatment Centers', url: '/hawaii/' },
  { title: 'Idaho', subtitle: 'Treatment Centers', url: '/idaho/' },
  { title: 'Illinois', subtitle: 'Treatment Centers', url: '/illinois/' },
  { title: 'Indiana', subtitle: 'Treatment Centers', url: '/indiana/' },
  { title: 'Iowa', subtitle: 'Treatment Centers', url: '/iowa/' },
  { title: 'Kansas', subtitle: 'Treatment Centers', url: '/kansas/' },
  { title: 'Kentucky', subtitle: 'Treatment Centers', url: '/kentucky/' },
  { title: 'Louisiana', subtitle: 'Treatment Centers', url: '/louisiana/' },
  { title: 'Maine', subtitle: 'Treatment Centers', url: '/maine/' },
  { title: 'Maryland', subtitle: 'Treatment Centers', url: '/maryland/' },
  {
    title: 'Massachusetts',
    subtitle: 'Treatment Centers',
    url: '/massachusetts/'
  },
  { title: 'Michigan', subtitle: 'Treatment Centers', url: '/michigan/' },
  { title: 'Minnesota', subtitle: 'Treatment Centers', url: '/minnesota/' },
  { title: 'Mississippi', subtitle: 'Treatment Centers', url: '/mississippi/' },
  { title: 'Missouri', subtitle: 'Treatment Centers', url: '/missouri/' },
  { title: 'Montana', subtitle: 'Treatment Centers', url: '/montana/' },
  { title: 'Nebraska', subtitle: 'Treatment Centers', url: '/nebraska/' },
  { title: 'Nevada', subtitle: 'Treatment Centers', url: '/nevada/' },
  {
    title: 'New Hampshire',
    subtitle: 'Treatment Centers',
    url: '/new-hampshire/'
  },
  { title: 'New Jersey', subtitle: 'Treatment Centers', url: '/new-jersey/' },
  { title: 'New Mexico', subtitle: 'Treatment Centers', url: '/new-mexico/' },
  { title: 'New York', subtitle: 'Treatment Centers', url: '/new-york/' },
  {
    title: 'North Carolina',
    subtitle: 'Treatment Centers',
    url: '/north-carolina/'
  },
  {
    title: 'North Dakota',
    subtitle: 'Treatment Centers',
    url: '/north-dakota/'
  },
  { title: 'Ohio', subtitle: 'Treatment Centers', url: '/ohio/' },
  { title: 'Oklahoma', subtitle: 'Treatment Centers', url: '/oklahoma/' },
  { title: 'Oregon', subtitle: 'Treatment Centers', url: '/oregon/' },
  {
    title: 'Pennsylvania',
    subtitle: 'Treatment Centers',
    url: '/pennsylvania/'
  },
  {
    title: 'Rhode Island',
    subtitle: 'Treatment Centers',
    url: '/rhode-island/'
  },
  {
    title: 'South Carolina',
    subtitle: 'Treatment Centers',
    url: '/south-carolina/'
  },
  {
    title: 'South Dakota',
    subtitle: 'Treatment Centers',
    url: '/south-dakota/'
  },
  { title: 'Tennessee', subtitle: 'Treatment Centers', url: '/tennessee/' },
  { title: 'Texas', subtitle: 'Treatment Centers', url: '/texas/' },
  { title: 'Utah', subtitle: 'Treatment Centers', url: '/utah/' },
  { title: 'Vermont', subtitle: 'Treatment Centers', url: '/vermont/' },
  { title: 'Virginia', subtitle: 'Treatment Centers', url: '/virginia/' },
  { title: 'Washington', subtitle: 'Treatment Centers', url: '/washington/' },
  {
    title: 'West Virginia',
    subtitle: 'Treatment Centers',
    url: '/west-virginia/'
  },
  { title: 'Wisconsin', subtitle: 'Treatment Centers', url: '/wisconsin/' },
  { title: 'Wyoming', subtitle: 'Treatment Centers', url: '/wyoming/' }
]

export const CONDITIONS_LINKS = [
  {
    title: 'Addiction',
    subtitle: 'Rehab Centers',
    url: '/united-states/'
  },
  { title: 'Anger', subtitle: 'Treatment Centers', url: '/condition/anger/' },
  {
    title: 'Anxiety',
    subtitle: 'Treatment Centers',
    url: '/condition/anxiety/'
  },
  {
    title: 'Bipolar Disorder',
    subtitle: 'Treatment Centers',
    url: '/condition/bipolar/'
  },
  {
    title: 'Burnout & Stress',
    subtitle: 'Treatment Centers',
    url: '/condition/burnout/'
  },
  {
    title: 'Co-Occurring Disorders',
    subtitle: 'Treatment Centers',
    url: '/condition/co-occurring-disorders/'
  },
  {
    title: 'Depression',
    subtitle: 'Treatment Centers',
    url: '/condition/depression/'
  },
  {
    title: 'Eating Disorders',
    subtitle: 'Treatment Centers',
    url: '/condition/eating-disorders/'
  },
  {
    title: 'Gambling',
    subtitle: 'Rehab Centers',
    url: '/condition/gambling/'
  },
  {
    title: 'Grief and Loss',
    subtitle: 'Treatment Centers',
    url: '/condition/grief-and-loss/'
  },
  { title: 'OCD', subtitle: 'Treatment Centers', url: '/condition/ocd/' },
  {
    title: 'PTSD',
    subtitle: 'Treatment Centers',
    url: '/condition/post-traumatic-stress-disorder/'
  },
  {
    title: 'Schizophrenia',
    subtitle: 'Treatment Centers',
    url: '/condition/schizophrenia/'
  },
  {
    title: 'Sex Addiction',
    subtitle: 'Rehab Centers',
    url: '/condition/sex-addiction/'
  },
  {
    title: 'Smoking Cessation',
    subtitle: 'Rehab Centers',
    url: '/condition/smoking-cessation/'
  },
  {
    title: 'Suicidality',
    subtitle: 'Treatment Centers',
    url: '/condition/suicidality/'
  },
  {
    title: 'Trauma',
    subtitle: 'Treatment Centers',
    url: '/condition/trauma/'
  }
]

export const DRUGS_LINKS = [
  { title: 'Alcohol', subtitle: 'Rehab Centers', url: '/condition/alcohol/' },
  {
    title: 'Benzodiazepines',
    subtitle: 'Rehab Centers',
    url: '/condition/benzodiazepines/'
  },
  { title: 'Cocaine', subtitle: 'Rehab Centers', url: '/condition/cocaine/' },
  { title: 'Heroin', subtitle: 'Rehab Centers', url: '/condition/heroin/' },
  {
    title: 'Marijuana',
    subtitle: 'Rehab Centers',
    url: '/condition/marijuana/'
  },
  {
    title: 'Methamphetamine',
    subtitle: 'Rehab Centers',
    url: '/condition/methamphetamine/'
  },
  { title: 'Opioids', subtitle: 'Rehab Centers', url: '/condition/opioids/' },
  {
    title: 'Synthetic Drugs',
    subtitle: 'Rehab Centers',
    url: '/condition/synthetic-drugs/'
  }
]
export const INSURANCE_LINKS = [
  { title: 'Aetna', subtitle: 'Verified Centers', url: '/insurance/aetna/' },
  {
    title: 'Ambetter',
    subtitle: 'Verified Centers',
    url: '/insurance/ambetter/'
  },
  { title: 'Anthem', subtitle: 'Verified Centers', url: '/insurance/anthem/' },
  {
    title: 'Bluecross',
    subtitle: 'Verified Centers',
    url: '/insurance/bluecross/'
  },
  {
    title: 'Carelon',
    subtitle: 'Verified Centers',
    url: '/insurance/carelon/'
  },
  { title: 'Cigna', subtitle: 'Verified Centers', url: '/insurance/cigna/' },
  {
    title: 'Compsych',
    subtitle: 'Verified Centers',
    url: '/insurance/compsych/'
  },
  {
    title: 'Healthnet',
    subtitle: 'Verified Centers',
    url: '/insurance/healthnet/'
  },
  { title: 'Humana', subtitle: 'Verified Centers', url: '/insurance/humana/' },
  {
    title: 'Kaiser',
    subtitle: 'Verified Centers',
    url: '/insurance/kaiser-permanente/'
  },
  {
    title: 'Medicaid',
    subtitle: 'Verified Centers',
    url: '/insurance/medicaid/'
  },
  {
    title: 'Medicare',
    subtitle: 'Verified Centers',
    url: '/insurance/medicare/'
  },
  { title: 'Optum', subtitle: 'Verified Centers', url: '/insurance/optum/' },
  { title: 'Oscar', subtitle: 'Verified Centers', url: '/insurance/oscar/' },
  {
    title: 'Tricare',
    subtitle: 'Verified Centers',
    url: '/insurance/tricare/'
  },
  {
    title: 'Tufts Health',
    subtitle: 'Verified Centers',
    url: '/insurance/tufts-health/'
  },
  { title: 'United', subtitle: 'Verified Centers', url: '/insurance/united/' }
]

export const MIN_FEATURED_CENTERS = 3
